export function getResponseTaskId(response, fallbackTaskId = null) {
  if (!response) return fallbackTaskId ?? null;

  const id =
    response.task_id ??
    response.taskId ??
    response.data?.task_id ??
    response.data?.taskId ??
    fallbackTaskId;

  return id != null && id !== "" ? id : null;
}

export function formatTaskSuccessMessage(response, defaultMessage, fallbackTaskId = null) {
  const taskId = getResponseTaskId(response, fallbackTaskId);
  const baseMessage =
    (typeof response?.message === "string" && response.message.trim()) || defaultMessage;

  if (taskId == null) return baseMessage;
  return `${baseMessage} (Task ID: ${taskId})`;
}
